import { Fragment } from 'react';

import Buttons from '@klv/molecules/buttons';
import MixedMedia from '@klv/molecules/mixed-media';
import useSlides from '@klv/hooks/useSlides';
import * as s from './styles';
import type { ITwoColumnSlider, ITwoColumnSliderRow } from './types';

const TwoColumnSlider = ({ rows }: ITwoColumnSlider) => {
  const { slides, setThisSlide, swipeable } = useSlides(rows, ['left', 'right']);

  return (
    <s.StyledTwoColumnSlider {...swipeable}>
      <s.StyledGrid>
        <s.Menu>
          {(rows.map((row, rowIndex) => (
            <s.MenuButton
              {...slides[rowIndex]}
              forwardedAs="button"
              key={row.menuItem}
              onClick={() => { setThisSlide(rowIndex); }}
              type="button"
              variant="navigation"
            >
              {row.menuItem}
            </s.MenuButton>
          )))}
        </s.Menu>
        {slides.map((slide: ITwoColumnSliderRow) => (
          <Fragment key={slide.headline}>
            <s.TwoColumnSliderText $current={slide.$current} $dir={slide.$dir}>
              {slide.headline && <s.StyledHeadline colorVariant="light" variant="h3">{slide.headline}</s.StyledHeadline>}
              <s.StyledBodyText colorVariant="light" dangerouslySetInnerHTML={{ __html: slide.body }} variant="paragraph2" />
              {slide?.buttons && <Buttons buttons={slide.buttons} variants={['ghost', 'tertiary']} buttonColor="light" />}
            </s.TwoColumnSliderText>
            <s.ImageContainer $current={slide.$current} $dir={slide.$dir} $segment={slide.$current ? 'in' : 'out'}>
              <MixedMedia mixedMedia={slide.mixedMedia} />
            </s.ImageContainer>
          </Fragment>
        ))}
      </s.StyledGrid>
    </s.StyledTwoColumnSlider>
  );
};

export default TwoColumnSlider;
